import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Textarea.css";
/**
 * @desc TextArea
 * @param props
 * @return null
 */


const Textarea = props => {
  const { className, label, errorMsg, inValid, ...other } = props;
  return (
    <div className={"ui-textarea " + className}>
      {label || errorMsg ? (
        <div className="label-wrapper">
          <label>{label}</label>
          <div className="form-error-message">{errorMsg}</div>
        </div>
      ) : null}
      <textarea
        {...other}
        className={inValid}
        onChange={props.onChange}
        defaultValue={props.value}
        data-enable-grammarly="false"
      />
    </div>
  );
};

Textarea.propTypes = {
  /** ClassName will be injected into the component's container. You can use ClassName for adhoc styling. */
  className: PropTypes.string,
  /** The label of the textarea */
  label: PropTypes.string
};

Textarea.defaultProps = {
  className: "",
  label: ""
};

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/UI/Textarea/Textarea.js